import {
  OverviewScreen,
  EngagementScreen,
  WellbeingScreen,
  ResetsAndContentScreen,
  ImplementationScreen,
  PaymentsAndLicensingScreen,
  PlatformHealthScreen,
  SettingsScreen,
  InboxScreen,
} from "../pages/Mcap";
import { EditProfile, ChangePassword } from "../pages/Account";

import { APP_ROUTES } from "../helpers/routeHelpers";
import { ACCESS } from "../helpers/access";
import { Roles } from "../constants";

let { Admin, User } = Roles;

// Every MCAP tab from the old admin-console hub page, now a standalone,
// sidebar-navigable top-level route. `permissions` follows the same shape
// the admin console uses (matched against UserType, ADMIN/USER — see
// DefaultLayout.js) — it is not the mcapAccess gate. That gate runs once,
// earlier: DefaultLayout only ever mounts these routes for a signed-in
// account whose GetMe response carried mcapAccess: true (see
// containers/DefaultLayout/DefaultLayout.js and McapAccessGuard on the
// backend, which independently enforces the same thing on every request).
//
// Both roles are listed because MCAP is no longer admin-only: a teacher or
// student account granted MCAP from the admin console sees the same org-wide
// tabs an admin does. Entry is decided entirely by mcapAccess now; this list
// no longer narrows it further.
const authProtectedRoutes = [
  {
    path: APP_ROUTES.OVERVIEW,
    component: OverviewScreen,
    permissions: [Admin, User],
    exact: true,
  },
  {
    path: APP_ROUTES.ENGAGEMENT,
    component: EngagementScreen,
    permissions: [Admin, User],
    exact: true,
  },
  {
    path: APP_ROUTES.WELLBEING,
    component: WellbeingScreen,
    permissions: [Admin, User],
    exact: true,
  },
  {
    path: APP_ROUTES.RESETS_CONTENT,
    component: ResetsAndContentScreen,
    permissions: [Admin, User],
    exact: true,
  },
  {
    path: APP_ROUTES.IMPLEMENTATION,
    component: ImplementationScreen,
    permissions: [Admin, User],
    exact: true,
  },
  {
    path: APP_ROUTES.PAYMENTS_LICENSING,
    component: PaymentsAndLicensingScreen,
    permissions: [Admin, User],
    exact: true,
  },
  {
    path: APP_ROUTES.PLATFORM_HEALTH,
    component: PlatformHealthScreen,
    permissions: [Admin, User],
    exact: true,
  },
  {
    path: APP_ROUTES.SETTINGS,
    component: SettingsScreen,
    permissions: [Admin, User],
    exact: true,
  },
  {
    // The one screen gated by inboxAccess instead of mcapAccess
    // (helpers/access.js). A sales teammate can have this alone.
    path: APP_ROUTES.INBOX,
    component: InboxScreen,
    permissions: [Admin, User],
    access: ACCESS.INBOX,
    exact: true,
  },
  {
    path: APP_ROUTES.EDIT_PROFILE,
    component: EditProfile,
    permissions: [Admin, User],
    access: ACCESS.ANY,
    exact: true,
  },
  {
    path: APP_ROUTES.CHANGE_PASSWORD,
    component: ChangePassword,
    permissions: [Admin, User],
    access: ACCESS.ANY,
    exact: true,
  },
];

export { authProtectedRoutes };
